import Modal from '../ui/Modal';
import { useTranslation } from '@/i18n';

interface PartnershipAnswerModalProps {
  closeModal: () => void;
  onConfirm: () => void;
  isAccepted: boolean;
}

const PartnershipAnswerModal = ({
  closeModal,
  onConfirm,
  isAccepted,
}: PartnershipAnswerModalProps) => {
  const { t } = useTranslation();
  const acceptingMessage = t(
    'distributors.partnershipRequests.acceptingMessage',
  );
  const refusingMessage = t('distributors.partnershipRequests.refusingMessage');

  return (
    <Modal
      title={
        isAccepted
          ? t('distributors.partnershipRequests.acceptTitle')
          : t('distributors.partnershipRequests.refuseTitle')
      }
      message={isAccepted ? acceptingMessage : refusingMessage}
      actionTitle={
        isAccepted
          ? t('distributors.partnershipRequests.accept')
          : t('distributors.partnershipRequests.refuse')
      }
      closeModal={closeModal}
      actionOnClick={onConfirm}
      specialColor={isAccepted ? 'success' : 'error'}
    />
  );
};

export default PartnershipAnswerModal;
